import { NgModule, ModuleWithProviders } from '@angular/core';

import { AuthenticationService } from './api/authentication.service';
import { BanksService } from './api/banks.service';
import { BannersService } from './api/banners.service';
import { BranchCostAppraisalsService } from './api/branchCostAppraisals.service';
import { BranchesService } from './api/branches.service';
import { ContentsService } from './api/contents.service';
import { CostAppraisalsService } from './api/costAppraisals.service';
import { FilesService } from './api/files.service';
import { FranchiseTiersService } from './api/franchiseTiers.service';
import { MasterDataService } from './api/masterData.service';
import { MeService } from './api/me.service';
import { MemberTiersService } from './api/memberTiers.service';
import { MembersService } from './api/members.service';
import { MiscellaneousProductsService } from './api/miscellaneousProducts.service';
import { OtpService } from './api/otp.service';
import { ProductCategoriesService } from './api/productCategories.service';
import { ProductsService } from './api/products.service';
import { PurchasesService } from './api/purchases.service';
import { ReportsService } from './api/reports.service';
import { RolesService } from './api/roles.service';
import { UnitsService } from './api/units.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    AuthenticationService,
    BanksService,
    BannersService,
    BranchCostAppraisalsService,
    BranchesService,
    ContentsService,
    CostAppraisalsService,
    FilesService,
    FranchiseTiersService,
    MasterDataService,
    MeService,
    MemberTiersService,
    MembersService,
    MiscellaneousProductsService,
    OtpService,
    ProductCategoriesService,
    ProductsService,
    PurchasesService,
    ReportsService,
    RolesService,
    UnitsService,
    UsersService,
  ],
})
export class ApiModule { }
